import M_ENV from '../../main/components/env/index.js'
import M_TOOLKIT from '../../main/components/toolkit/index.js'
import M_BRIDGE from '../components/bridge/index.js'
import M_AXIOS from 'axios' 
import M_ROOT_VERIFY from './components/root_verify/index.js'

const G_ERR_INFO = {
    dataOversize: {
        'errcode': '10003',
        'retmsg': 'data oversize'
    },
    etOversize: {
        'errcode': '10003',
        'retmsg': 'extend_info oversize'
    },
    setOversize: {
        'errcode': '10003',
        'retmsg': 'standard_extend_info oversize'
    }
}

const G_DATA_LIMIT = '8388608' // 8M
const G_EXTEND_LIMIT = '1048576' // 1M

// 上报类
class Report {
    constructor (){
       
    }

    /**
     * @description: 外部执行方法
     * @param {String} cmd 指令
     * @param {Object} main 外部实例
     * @param {Object} params 传入参数
     */    
    execute (cmd, main, params){
        // 总开关
        if (!main.mainSwitch) {
            return
        }
        switch (cmd) {
            case 'base': // 基础上报
                this.baseReport(main, params)
                break
            case 'force': // 强制上报
                this.forceReport(main, params)
                break
            default:
                break
        }
    }

    /**
     * @description: 基础上报
     * @param {Object} main 上层实例
     * @param {Object} params 上报参数
     */    
    baseReport (main, params){
        const pass_verify = M_ROOT_VERIFY(main, params)
        // 通过路由校验才能上报
        if (!pass_verify) {
            return
        }
        // APP内
        if (M_ENV.isInApp) {
            // 将上报消息体取出，由APP上报
            const data = params.content && params.content.data && params.content.data.record_list && params.content.data.record_list[0]
            const hasData = M_TOOLKIT.isObject(data) && !M_TOOLKIT.isEmptyObject(data)
            hasData && M_BRIDGE.invoke('unifyReport', {
                params: data,
                callback: () => {}
            })
        } else { // H5

            let check = this._checkReportData(main, params)
            
            // H5校验数据量级
            if (!check.result) {
                return
            }

            M_AXIOS.post('https://dc.fenqile.com/route0031/dataCollect/uploadWebDataSingleReport.json', { 
                data: params 
            })
        }
    }
    /**
     * @description: 强制上报
     */    
    forceReport (){
        // todo
    }

    /**
     * 上报前检查上报体积，总体积小于8M，extendinfo 小于1M
     * @param {Object} main 上层实例
     * @param  {Object} params 单条上报参数
     * @returns {Object}
     */
    _checkReportData (main, params) {
        let res = {
            result: true,
            result_rows: {}
        }
        let str = JSON.stringify(params)
        let data = params.content && params.content.data && params.content.data.record_list && params.content.data.record_list[0] || {}
        
        // todo 后续如果出现stringify异常，可以使用npm包：object-sizeof
        // 先校验总体积
        if (str.length > G_DATA_LIMIT) {
            res.result = false
            res.result_rows = G_ERR_INFO.dataOversize

            // 上报采集
            main.pageReport({
                event_pos: 'FENQILE_APP.COMMON.REPORT.DATA_OVERSIZE',
                event_pos_name: '单条数据字节数超过限制',
                extend_info: {
                    event_pos: data.event_pos || ''
                }
            })

        } else if (data.extend_info && JSON.stringify(data.extend_info).length > G_EXTEND_LIMIT) { // extend info 校验
            res.result = false
            res.result_rows = G_ERR_INFO.etOversize

            // 上报采集
            main.pageReport({
                event_pos: 'FENQILE_APP.COMMON.REPORT.EXTEND_INFO_OVERSIZE',
                event_pos_name: 'EXTEND_INFO字节数超过限制',
                extend_info: {
                    event_pos: data.event_pos || ''
                }
            })
        } else if (data.standard_extend_info && JSON.stringify(data.standard_extend_info).length > G_EXTEND_LIMIT) {
            res.result = false
            res.result_rows = G_ERR_INFO.setOversize

            // 上报采集
            main.pageReport({
                event_pos: 'FENQILE_APP.COMMON.REPORT.STANDARD_EXTEND_INFO_OVERSIZE',
                event_pos_name: 'STANDARD_EXTEND_INFO字节数超过限制',
                extend_info: {
                    event_pos: data.event_pos || ''
                }
            })
        }   

        return res
    }
}

export default new Report()